import CrmScope from 'components/crm/ui/CrmScope';
import RichSelect from 'components/crm/ui/RichSelect';
import { AddProspectForm } from 'components/prospection/AddProspectDrawer';
import SlideOverAddCompany from 'components/SlideOver/dataSlideOver/data/slideOverCompany/slideOverAddCompany';
import SlideOverBody from 'components/SlideOver/component/body';
import SlideOverFooter from 'components/SlideOver/component/footer';
import SlideOverHeader from 'components/SlideOver/component/header';
import useSlideOver from 'components/SlideOver/useSlideOver';
import { useNotifyCompaniesChanged } from 'hooks/useCompaniesChanged';
import UseContext from 'hooks/useContext';
import useText from 'hooks/useText';
import { Building2, Target } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

/**
 * « Ajouter une entreprise » (slide-over `add_company`), as on the prototype:
 * its « Type » first, a prospect to approach (the form of the prospection, a
 * name and a phone are enough, the commercial in charge) or a client company
 * (the full form, which can order missions at once). A prospect added opens
 * its page.
 */
const AddCompanyPanel = () => {
  const { text } = useText('companies');
  const { removeAllParameters } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  const notify = useNotifyCompaniesChanged();
  const navigate = useNavigate();
  const [type, setType] = useState('prospect');
  const close = () => {
    toggleSlideOver();
    removeAllParameters();
  };

  const typeField = (
    <CrmScope>
      <RichSelect
        id="company-type"
        label={text('addType.label')}
        value={type}
        options={[
          { value: 'prospect', label: text('addType.prospect'), description: text('addType.prospectHelp'), icon: Target, iconClass: 'text-primary' },
          { value: 'client', label: text('addType.client'), description: text('addType.clientHelp'), icon: Building2, iconClass: 'text-mint' },
        ]}
        hint={text(type === 'prospect' ? 'addType.hintProspect' : 'addType.hintClient')}
        onChange={setType}
      />
    </CrmScope>
  );

  if (type === 'client') return <SlideOverAddCompany prepend={typeField} />;
  return (
    <AddProspectForm
      onClose={close}
      onAdded={(result) => {
        toast.success(text('addType.prospectAdded'));
        notify();
        close();
        if (result?.company?.id) navigate(`/company/${result.company.id}`);
      }}
      frame={({ body, footer }) => (
        <>
          <SlideOverHeader hide={close} hideShow>
            {text('addType.title')}
          </SlideOverHeader>
          <SlideOverBody>
            <div className="flex flex-col gap-6">
              {typeField}
              {body}
            </div>
          </SlideOverBody>
          <div className="flex-shrink-0 border-t border-gray-100">
            <SlideOverFooter>{footer}</SlideOverFooter>
          </div>
        </>
      )}
    />
  );
};

export default AddCompanyPanel;
